import Blockly from 'blockly/browser'
import { defineBlock, defineStmtBlock, getStatements } from '../Util'

defineBlock(
  'javascript_for_loop',
  {
    message0: '%1 when %2 do %3 update %4',
    args0: [
      {
        type: 'input_statement',
        name: 'init'
      },
      {
        type: 'input_value',
        name: 'test'
      },
      {
        type: 'input_statement',
        name: 'body'
      },
      {
        type: 'input_statement',
        name: 'update'
      }
    ],
    previousStatement: null,
    nextStatement: null,
    tooltip: 'for-loop',
    colour: Blockly.Msg.LOOPS_HUE
  },
  function(block) {
    let statementsInit = getStatements(block.getInputTargetBlock('init')).join(', ') || ''
    if (statementsInit) {
      statementsInit = 'var ' + statementsInit
    }
    const valueTest = Blockly.JavaScript.valueToCode(block, 'test', Blockly.JavaScript.ORDER_NONE)
    const statementsBody = Blockly.JavaScript.statementToCode(block, 'body') || ''
    const statementsUpdate = getStatements(block.getInputTargetBlock('update')).join(', ') || ''
    const code = `for (${statementsInit}; ${valueTest}; ${statementsUpdate}) {\n${statementsBody}}\n`
    return code
  }
)

defineStmtBlock(
  'javascript_for_of_loop',
  {
    message0: 'for each %1 in %2 do %3',
    args0: [
      {
        type: 'field_input',
        name: 'VARIABLE',
        text: 'x'
      },
      {
        type: 'input_value',
        name: 'ARRAY',
        check: 'Array'
      },
      {
        type: 'input_statement',
        name: 'DO'
      }
    ],
    tooltip: 'Iterates over the elements of a list/array',
    colour: Blockly.Msg.LOOPS_HUE
  },
  block => {
    var variable = block.getFieldValue('VARIABLE')
    var array =
      Blockly.JavaScript.valueToCode(block, 'ARRAY', Blockly.JavaScript.ORDER_NONE) || 'null'
    var doStatements = Blockly.JavaScript.statementToCode(block, 'DO') || ''
    var code = `for (var _arr = ${array}, _i = 0; _i < _arr.length; _i++) { var ${variable} = _arr[_i];\n${doStatements}}\n`
    return code
  }
)
